import cn from "classnames";

import styles from "./index.module.scss";

const AuthPageContainer = ({ className, ...rest }: any) => {
  return <div {...rest} className={cn(styles.container, className)} />;
};

export default AuthPageContainer;
